import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Button } from "reactstrap";
import { LINKED_IN_ACCOUNTS_SIDE_MODAL_RIGHT } from "../../../../constants/modal.constant";
import { useGlobalCore } from "../../../../cores/globals";
import { useLinkedInBusinessCore } from "../../../../cores/linkedInBusiness";
import { Organization } from "../../../../cores/linkedInBusiness/interface/api/post-linkedinBussiness-organizations";
import { useMeCore } from "../../../../cores/me";

interface BindData {
  accessToken: string;
  refreshToken: string;
  expiresIn: string;
}

interface Props {
  bindData: BindData;
}

export default function LinkedInAccounts(props: Props) {
  const { organizations } = useLinkedInBusinessCore();
  const { bindData } = props;
  const intl = useIntl();
  return (
    <div className="p-4 social-account-picker">
      <h2 className="h2 text-center mb-4 social-account-picker__title">
        {intl.formatMessage({id: "app.linkedin.chooseAcount"})}
      </h2>
      {organizations.map((organization) => (
        <LinkedInAccount key={organization.id} organization={organization} bindData={bindData} />
      ))}
    </div>
  );
}

const LinkedInAccount = ({
  organization,
  bindData,
}: {
  organization: Organization;
  bindData: BindData;
}) => {
  const intl = useIntl();
  const { avatarUrl, name, id: organizationId } = organization;
  const { accessToken, refreshToken, expiresIn } = bindData;
  const { bind } = useLinkedInBusinessCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { turnOffModal } = useGlobalCore();
  const handleBind = useCallback(async () => {
    await bind(
      company!.id,
      accessToken,
      refreshToken,
      expiresIn,
      organizationId
    );
    getMeSocialSettings(company?.id!);
    turnOffModal(LINKED_IN_ACCOUNTS_SIDE_MODAL_RIGHT);
  }, [
    bind,
    company,
    getMeSocialSettings,
    accessToken,
    refreshToken,
    expiresIn,
    organizationId,
    turnOffModal,
  ]);

  return (
    <div className="align-items-center d-flex p-2 neu-in pointer social-account-picker__item">
      <img
        style={{ width: "50px", height: "50px" }}
        className="rounded-circle social-account-picker__avatar"
        src={avatarUrl}
        alt="Avatar"
      />
      <span className="h5 ml-3 mb-0 social-account-picker__name"> {name} </span>
      <Button className="ml-auto social-account-picker__sync-btn" color="primary" onClick={handleBind}>
        {intl.formatMessage({id : "app.sincronyze"})}
      </Button>
    </div>
  );
};
